/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React from "react";
import { FeedModelComponentDisplay } from "cms/components/components/feed-model/display";
import { FeedModelComponentEditor } from "cms/components/components/feed-model/edit";
import { getComponentZoneLayout } from "cms/components/components/component";

function FeedModelComponent (props) {
    
    const { ...everything } = props;
    const zoneProps = {
        ...everything,
        displayComponent: <FeedModelComponentDisplay />,
        editComponent: <FeedModelComponentEditor />,
    };
    return getComponentZoneLayout(zoneProps);
}

FeedModelComponent.displayName = "FeedModelComponent";
export { FeedModelComponent };
